import React from "react";

const stats = [
  {
    value: "0.5% – 2.0%",
    label: "Of the disbursed amount, by product",
  },
  {
    value: "T+7",
    label: "Payout cycle after disbursal",
  },
  {
    value: "₹0",
    label: "Onboarding or platform fee",
  },
];

function Commission() {
  return (
    <section className="overflow-hidden bg-[#191e1c] section-spacing">
      <div className="section-container">
        {/* Card Container */}
        <div className="relative overflow-hidden rounded-[24px] border border-[#2EE5A2]/30 bg-[#141917] p-6 sm:rounded-[28px] sm:p-10 lg:rounded-[32px] lg:p-14">
          {/* Header */}
          <div>
            {/* Label */}
            <p className="font-jakarta text-[11px] font-medium tracking-[0.34em] text-[var(--mint-green)] sm:text-[12px]">
              COMMISSION
            </p>

            {/* Heading */}
            <h2 className="mt-3.5 font-bricolage text-[24px] font-semibold tracking-[-0.5px] text-white sm:mt-4 sm:text-[28px] md:text-[32px]">
              Paid on disbursal. Nothing hidden.
            </h2>
          </div>

          {/* Stats Grid */}
          <div className="mt-10 grid grid-cols-1 gap-8 sm:mt-12 sm:grid-cols-3 sm:gap-8 lg:mt-14 lg:gap-12">
            {stats.map((item) => (
              <div key={item.label}>
                <p className="font-bricolage text-[32px] font-semibold leading-none tracking-[-1px] text-[var(--mint-green)] sm:text-[36px] lg:text-[40px]">
                  {item.value}
                </p>

                <p className="mt-3 font-jakarta text-[13px] leading-snug text-[#97a39e] sm:text-[14px]">
                  {item.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Commission;
